import { render } from "./AposSettingsManager.vue?vue&type=template&id=6a17a0ad&scoped=true"
import script from "./AposSettingsManager.vue?vue&type=script&lang=js"
export * from "./AposSettingsManager.vue?vue&type=script&lang=js"

import "./AposSettingsManager.vue?vue&type=style&index=0&id=6a17a0ad&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a17a0ad"],['__file',"settings/ui/apos/components/AposSettingsManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a17a0ad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a17a0ad', __exports__)) {
    api.reload('6a17a0ad', __exports__)
  }
  
  module.hot.accept("./AposSettingsManager.vue?vue&type=template&id=6a17a0ad&scoped=true", () => {
    api.rerender('6a17a0ad', render)
  })

}


export default __exports__